

export const veoShowcase = {
    header: 'AI Generated Video',
    badge: 'AI Video',
    title: 'Text to Video',
    subtitle:
      'With detailed text descriptions, AI models understand your creative vision and generate cinematic content with native audio and realistic motion',
    promptLabel: 'Prompt',
    promptText:
      'A cinematic, high-detail drone shot starting from a wide view of a futuristic neon-lit city in the rain at night, smoothly gliding down to a close-up of a single glowing blue butterfly landing on a wet metal railing. As the butterfly lands, its wings pulse with light, reflecting perfectly in the raindrops. The camera movement is fluid and professional, with realistic motion blur and cinematic bokeh background. 8k resolution, highly detailed textures, vibrant cyberpunk color palette.'
  };
